import React from 'react';
import { Link } from 'react-router-dom';

export default function SmsConsentCheckbox({
    name = 'smsNotificationsConsent',
    checked,
    onChange,
    error,
    style,
    required = false,
    variant = 'transactional',
}) {
    const isMarketing = variant === 'marketing';

    return (
        <>
            <div className={`checkbox-container ${error ? 'has-error' : ''}`} style={style}>
                <label className="label-checkbox">
                    <input
                        type="checkbox"
                        name={name}
                        checked={checked}
                        onChange={onChange}
                        aria-invalid={!!error}
                        required={required}
                    />
                    <div className="psevdocheckbox"></div>
                </label>
                <span className="text-left">
                    {isMarketing ? (
                        <>
                            By checking this box, I consent to receive recurring promotional and marketing SMS messages
                            from Law.Law at the phone number provided. Consent is not a condition of purchase. Max 4
                            msgs/month. Text STOP to cancel.
                        </>
                    ) : (
                        <>
                            By checking this box, I consent to receive recurring SMS messages from Law.Law to the phone
                            number provided, including transactional and informational messages. Message &amp; data rates
                            may apply. Message frequency varies. Reply STOP to cancel or HELP for assistance. See our{' '}
                            <Link to="/terms-of-use" className="checkbox__link" target="_blank" rel="noopener noreferrer">
                                Terms of Service
                            </Link>{' '}
                            and{' '}
                            <Link to="/privacy-policy" className="checkbox__link" target="_blank" rel="noopener noreferrer">
                                Privacy Policy
                            </Link>
                            .
                        </>
                    )}
                </span>
            </div>
            {error && <span className="error-message terms-error">{error}</span>}
        </>
    );
}
